<template>

  <div ref="formStep" class="form-step" data-step="0">
    <div class="herocontainer">
      <picture>
        <source media="(min-width:1680px)" srcset="@/assets/img/mann_ohneschatten_small.webp">
        <source media="(min-width:1280px)" srcset="@/assets/img/mann_ohneschatten_small.webp">
        <source media="(min-width:480px)" srcset="@/assets/img/mann_ohneschatten_small.webp">
        <img ref="image1" src="@/assets/img/mann_ohneschatten_small.webp"/>
      </picture>
      <picture>
        <source media="(min-width:1680px)" srcset="@/assets/img/frau_ohneschatten_small.webp">
        <source media="(min-width:1280px)" srcset="@/assets/img/frau_ohneschatten_small.webp">
        <source media="(min-width:480px)" srcset="@/assets/img/frau_ohneschatten_small.webp">
        <img ref="image2"  src="@/assets/img/frau_ohneschatten_small.webp"/>
      </picture>
      <picture>
        <img loading="lazy" src="@/assets/img/nrwwappen_schatten.png"/>
      </picture>


    </div>
    <form @submit.prevent="submitForm">
      <div ref="formContent" class="form-content">
        <div>
          <p class="speechbubble_anim">{{ $t('formContent.speechbubble_anim')}}</p>
        </div>
      </div>
      <button
          type="submit"
          ref="nextStepButton"
          class="button nextstep"
      >
        <img src="@/assets/img/edit_black.svg"/><span>{{ $t('formContent.Step1formLabel')}}</span><img
          src="@/assets/img/arrow-right.svg"/>
      </button>
    </form>
  </div>
</template>

<script>
import {gsap} from "gsap";
import {ref, onMounted} from "vue";

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Erstellen einer lokalen Kopie der Prop-Daten
      localFormData: JSON.parse(JSON.stringify(this.formData)),
    };
  },
  mount() {
    this.initView();
  },
  methods: {
    submitForm() {
      // Senden eines Ereignisses mit der aktualisierten lokalen Kopie der Daten
      this.$emit('update', this.localFormData);
      this.$emit('next');
    },
    initView() {

    }
  },
  setup() {
    const image1 = ref(null);
    const image2 = ref(null);
    const formContent = ref(null);
    const nextStepButton = ref(null);
    const formStep = ref(null);

    onMounted(() => {
      var splitTextTimeline = gsap.timeline();
      splitTextTimeline.to(formStep.value, {display:"flex", autoAlpha:1});
      splitTextTimeline.from(image1.value, {autoAlpha: 0, x: 20});
      splitTextTimeline.from(image2.value, {autoAlpha: 0, x: 40});
      splitTextTimeline.from(formContent.value, {autoAlpha: 0, y: 40});
      splitTextTimeline.to(nextStepButton.value, {y: 0, autoAlpha: 1});
    });

    return {
      image1,
      image2,
      formContent,
      formStep,
      nextStepButton,
    };
  },
};
</script>


<style lang="scss">

</style>


